export enum indications {
  psoriasis = "L40",
  dermatitis = "L20",
  hand_eczema = "hand_eczema",
}
interface HealthInsurance {
  id: number
  name: string
  isActive: boolean
  supportedDiagnoses?: indications[]
}
const barmer: HealthInsurance = {
  id: 1,
  name: "BARMER",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis, indications.dermatitis]
}
const dakGesundheit: HealthInsurance = {
  id: 2,
  name: "DAK Gesundheit",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis]
}
const hek: HealthInsurance = {
  id: 3,
  name: "HEK - Hanseatische Krankenkasse",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis, indications.dermatitis],
}
const hkk: HealthInsurance = {
  id: 4,
  name: "hkk Krankenkasse",
  isActive: false,
}
const kkh: HealthInsurance = {
  id: 5,
  name: "KKH Kaufmännische Krankenkasse",
  isActive: false,
}
const knappschaft: HealthInsurance = {
  id: 6,
  name: "KNAPPSCHAFT",
  isActive: false,
}
const tk: HealthInsurance = {
  id: 7,
  name: "Techniker Krankenkasse (TK)",
  isActive: false,
}
const big: HealthInsurance = {
  id: 8,
  name: "BIG direkt gesund",
  isActive: false,
}
const ikkInnovationskasse: HealthInsurance = {
  id: 9,
  name: "IKK - Die Innovationskasse",
  isActive: false,
}
const ikkBrandenburgBerlin: HealthInsurance = {
  id: 10,
  name: "IKK Brandenburg und Berlin",
  isActive: false,
}
const ikkClassic: HealthInsurance = {
  id: 11,
  name: "IKK classic",
  isActive: false,
}
const ikkGesundPlus: HealthInsurance = {
  id: 12,
  name: "IKK gesund plus",
  isActive: false,
}
const ikkSuedwest: HealthInsurance = {
  id: 13,
  name: "IKK Südwest",
  isActive: false,
}
const aokBadenWuerttemberg: HealthInsurance = {
  id: 14,
  name: "AOK Baden-Württemberg",
  isActive: false,
}
const aokBayern: HealthInsurance = {
  id: 15,
  name: "AOK Bayern",
  isActive: false,
}
const aokBremenBremerhaven: HealthInsurance = {
  id: 16,
  name: "AOK Bremen/Bremerhaven",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis],
}
const aokHessen: HealthInsurance = {
  id: 17,
  name: "AOK Hessen",
  isActive: false,
}
const aokNiedersachsen: HealthInsurance = {
  id: 18,
  name: "AOK Niedersachsen",
  isActive: false,
}
const aokNordost: HealthInsurance = {
  id: 19,
  name: "AOK Nordost",
  isActive: false,
}
const aokNordwest: HealthInsurance = {
  id: 20,
  name: "AOK Nordwest",
  isActive: false,
}
const aokPlus: HealthInsurance = {
  id: 21,
  name: "AOK PLUS",
  isActive: false,
}
const aokRheinlandPfalzSaarland: HealthInsurance = {
  id: 22,
  name: "AOK Rheinland-Pfalz/Saarland",
  isActive: false,
}
const aokRheinlandHamburg: HealthInsurance = {
  id: 23,
  name: "AOK Rheinland/Hamburg",
  isActive: false,
}
const aokSachsenAnhalt: HealthInsurance = {
  id: 24,
  name: "AOK Sachsen-Anhalt",
  isActive: false,
}
const audiBkk: HealthInsurance = {
  id: 25,
  name: "Audi BKK",
  isActive: false,
}
const bahnBkk: HealthInsurance = {
  id: 26,
  name: "BAHN-BKK",
  isActive: false,
}
const bergischeKrankenkasse: HealthInsurance = {
  id: 27,
  name: "BERGISCHE KRANKENKASSE",
  isActive: false,
}
const bertelsmannBkk: HealthInsurance = {
  id: 28,
  name: "Bertelsmann BKK",
  isActive: false,
}
const bkkAkzoNobelBayern: HealthInsurance = {
  id: 29,
  name: "BKK Akzo Nobel Bayern",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis],
}
const bkkDiakonie: HealthInsurance = {
  id: 30,
  name: "BKK Diakonie",
  isActive: false,
}
const bkkDuerkoppAdler: HealthInsurance = {
  id: 31,
  name: "BKK DürkoppAdler",
  isActive: false,
}
const bkkEuregio: HealthInsurance = {
  id: 32,
  name: "BKK EUREGIO",
  isActive: false,
}
const bkkExklusiv: HealthInsurance = {
  id: 33,
  name: "BKK exklusiv",
  isActive: false,
}
const bkkFaberCastellPartner: HealthInsurance = {
  id: 34,
  name: "BKK Faber-Castell & Partner",
  isActive: false,
}
const bkkFirmus: HealthInsurance = {
  id: 35,
  name: "BKK firmus",
  isActive: false,
}
const bkkFreudenberg: HealthInsurance = {
  id: 36,
  name: "BKK Freudenberg",
  isActive: false,
}
const bkkGildemeisterSeidensticker: HealthInsurance = {
  id: 37,
  name: "BKK GILDEMEISTER SEIDENSTICKER",
  isActive: false,
}
const bkkHerkules: HealthInsurance = {
  id: 38,
  name: "BKK HERKULES",
  isActive: false,
}
const bkkLinde: HealthInsurance = {
  id: 39,
  name: "BKK Linde",
  isActive: false,
}
const bkkMelittaHmr: HealthInsurance = {
  id: 40,
  name: "bkk melitta hmr",
  isActive: false,
}
const bkkPfaff: HealthInsurance = {
  id: 41,
  name: "BKK PFAFF",
  isActive: false,
}
const bkkPfalz: HealthInsurance = {
  id: 42,
  name: "BKK Pfalz",
  isActive: false,
}
const bkkProVita: HealthInsurance = {
  id: 43,
  name: "BKK ProVita",
  isActive: false,
}
const bkkPublic: HealthInsurance = {
  id: 44,
  name: "BKK Public",
  isActive: false,
}
const bkkSbh: HealthInsurance = {
  id: 45,
  name: "BKK SBH",
  isActive: false,
}
const bkkScheufelen: HealthInsurance = {
  id: 46,
  name: "BKK Scheufelen",
  isActive: false,
}
const bkkTechnoform: HealthInsurance = {
  id: 47,
  name: "BKK Technoform",
  isActive: false,
}
const bkkVdn: HealthInsurance = {
  id: 48,
  name: "BKK VDN",
  isActive: false,
}
const bkkVerbundPlus: HealthInsurance = {
  id: 49,
  name: "BKK VerbundPlus",
  isActive: false,
}
const bkkWerraMeissner: HealthInsurance = {
  id: 50,
  name: "BKK Werra-Meissner",
  isActive: false,
}
const bkkWirtschaftFinanzen: HealthInsurance = {
  id: 51,
  name: "BKK WIRTSCHAFT & FINANZEN",
  isActive: false,
}
const bkkZfPartner: HealthInsurance = {
  id: 52,
  name: "BKK ZF & Partner",
  isActive: false,
}
const bkk24: HealthInsurance = {
  id: 53,
  name: "BKK24",
  isActive: false,
}
const boschBkk: HealthInsurance = {
  id: 54,
  name: "Bosch BKK",
  isActive: false,
}
const continentaleBkk: HealthInsurance = {
  id: 55,
  name: "Continentale BKK",
  isActive: false,
}
const debekaBkk: HealthInsurance = {
  id: 56,
  name: "Debeka BKK",
  isActive: false,
}
const energieBkk: HealthInsurance = {
  id: 57,
  name: "energie-BKK",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis, indications.dermatitis],
}
const heimatKrankenkasse: HealthInsurance = {
  id: 58,
  name: "Heimat Krankenkasse",
  isActive: false,
}
const mhplusKrankenkasse: HealthInsurance = {
  id: 59,
  name: "mhplus Krankenkasse",
  isActive: false,
}
const mkkMeineKrankenkasse: HealthInsurance = {
  id: 60,
  name: "mkk-meine krankenkasse",
  isActive: false,
}
const mobilKrankenkasse: HealthInsurance = {
  id: 61,
  name: "Mobil Krankenkasse",
  isActive: false,
}
const novitasBkk: HealthInsurance = {
  id: 62,
  name: "novitas bkk",
  isActive: false,
}
const pronovaBkk: HealthInsurance = {
  id: 63,
  name: "Pronova BKK",
  isActive: false,
}
const rvBetriebskrankenkasse: HealthInsurance = {
  id: 64,
  name: "R+V Betriebskrankenkasse",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis, indications.dermatitis]
}
const salusBkk: HealthInsurance = {
  id: 65,
  name: "Salus BKK",
  isActive: false,
}
const sbk: HealthInsurance = {
  id: 66,
  name: "SBK",
  isActive: false,
}
const securvitaKrankenkasse: HealthInsurance = {
  id: 67,
  name: "SECURVITA Krankenkasse",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis, indications.dermatitis],
}
const skdBkk: HealthInsurance = {
  id: 68,
  name: "SKD BKK",
  isActive: false,
}
const tuiBkk: HealthInsurance = {
  id: 69,
  name: "TUI BKK",
  isActive: false,
}
const viactivKrankenkasse: HealthInsurance = {
  id: 70,
  name: "VIACTIV Krankenkasse",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis, indications.dermatitis],
}
const vividaBkk: HealthInsurance = {
  id: 71,
  name: "vivida bkk",
  isActive: false,
}
const wmfBkk: HealthInsurance = {
  id: 72,
  name: "WMF BKK",
  isActive: false,
}
const lkk: HealthInsurance = {
  id: 73,
  name: "Landwirtschaftliche Krankenkasse - LKK",
  isActive: false,
}
const bkkBBraunAesculap: HealthInsurance = {
  id: 74,
  name: "BKK B. Braun Aesculap",
  isActive: true,
  supportedDiagnoses: [indications.psoriasis, indications.dermatitis],
}
const bkkDeutscheBankAg: HealthInsurance = {
  id: 75,
  name: "BKK Deutsche Bank AG",
  isActive: false,
}
const bkkEvm: HealthInsurance = {
  id: 76,
  name: "BKK evm",
  isActive: false,
}
const bkkEwe: HealthInsurance = {
  id: 77,
  name: "BKK EWE",
  isActive: false,
}
const bkkGrozBeckert: HealthInsurance = {
  id: 78,
  name: "BKK Groz-Beckert",
  isActive: false,
}
const bkkKarlMayer: HealthInsurance = {
  id: 79,
  name: "BKK KARL MAYER",
  isActive: false,
}
const bkkMahle: HealthInsurance = {
  id: 80,
  name: "BKK MAHLE",
  isActive: false,
}
const bkkMerck: HealthInsurance = {
  id: 81,
  name: "BKK Merck",
  isActive: false,
}
const bkkMiele: HealthInsurance = {
  id: 82,
  name: "BKK Miele",
  isActive: false,
}
const bkkMtu: HealthInsurance = {
  id: 83,
  name: "BKK MTU",
  isActive: false,
}
const bkkPwc: HealthInsurance = {
  id: 84,
  name: "BKK PwC",
  isActive: false,
}
const bkkRiekerRicostaWeisser: HealthInsurance = {
  id: 85,
  name: "BKK Rieker.Ricosta.Weisser",
  isActive: false,
}
const bkkSalzgitter: HealthInsurance = {
  id: 86,
  name: "BKK Salzgitter",
  isActive: false,
}
const bkkVoralbHellerIndexLeuze: HealthInsurance = {
  id: 87,
  name: "BKK Voralb HELLER*INDEX*LEUZE",
  isActive: false,
}
const bkkWuerth: HealthInsurance = {
  id: 88,
  name: "BKK Würth",
  isActive: false,
}
const bmwBkk: HealthInsurance = {
  id: 89,
  name: "BMW BKK",
  isActive: false,
}
const ernstYoungBkk: HealthInsurance = {
  id: 90,
  name: "Ernst & Young BKK",
  isActive: false,
}
const koenigBauerBkk: HealthInsurance = {
  id: 91,
  name: "Koenig & Bauer BKK",
  isActive: false,
}
const kronesBkk: HealthInsurance = {
  id: 92,
  name: "Krones BKK",
  isActive: false,
}
const mercedesBenzBkk: HealthInsurance = {
  id: 93,
  name: "Mercedes-Benz BKK",
  isActive: false,
}
const suedzuckerBkk: HealthInsurance = {
  id: 94,
  name: "Südzucker-BKK",
  isActive: false,
}
const bkkBpwBergischeAchsenKg: HealthInsurance = {
  id: 104,
  name: "BKK BPW Bergische Achsen KG",
  isActive: false,
}
const actimondaKrankenkasse: HealthInsurance = {
  id: 95,
  name: "actimonda krankenkasse - jetzt: BIG direkt gesund",
  isActive: false,
}
const atlasBkkAhlmann: HealthInsurance = {
  id: 96,
  name: "atlas BKK ahlmann - jetzt: vivida bkk",
  isActive: false,
}
const bkkAchenbachBuschhuetten: HealthInsurance = {
  id: 97,
  name: "BKK Achenbach Buschhütten - jetzt: VIACTIV",
  isActive: false,
}
const bkkAdvita: HealthInsurance = {
  id: 98,
  name: "BKK advita - jetzt: BKK24",
  isActive: false,
}
const bkkAxelSpringer: HealthInsurance = {
  id: 100,
  name: "BKK AXEL SPRINGER - jetzt: DAK Gesundheit",
  isActive: false,
}
const bkkBasell: HealthInsurance = {
  id: 101,
  name: "BKK Basell - jetzt: BKK VBU",
  isActive: false,
}
const bkkBeiersdorfAg: HealthInsurance = {
  id: 102,
  name: "BKK Beiersdorf AG - jetzt: DAK Gesundheit",
  isActive: false,
}
const bkkBjb: HealthInsurance = {
  id: 103,
  name: "BKK BJB - jetzt: BKK Gildemeister Seidensticker",
  isActive: false,
}

const bkkBraunGillette: HealthInsurance = {
  id: 105,
  name: "BKK Braun-Gillette - jetzt: pronova BKK",
  isActive: false,
}
const bkkDemagKraussMaffei: HealthInsurance = {
  id: 106,
  name: "BKK Demag Krauss-Maffei - jetzt: BKK VBU",
  isActive: false,
}
const bkkEssanelle: HealthInsurance = {
  id: 107,
  name: "BKK ESSANELLE - jetzt: BARMER",
  isActive: false,
}
const bkkFamily: HealthInsurance = {
  id: 108,
  name: "BKK family - jetzt: BKK ProVita",
  isActive: false,
}
const bkkFutur: HealthInsurance = {
  id: 109,
  name: "BKK futur - jetzt BKK VBU",
  isActive: false,
}
const bkkGesundheit: HealthInsurance = {
  id: 110,
  name: "BKK Gesundheit - jetzt: DAK Gesundheit",
  isActive: false,
}
const bkkGrilloWerkeAg: HealthInsurance = {
  id: 111,
  name: "BKK GRILLO-WERKE AG",
  isActive: false,
}
const bkkHeimbach: HealthInsurance = {
  id: 112,
  name: "BKK Heimbach - jetzt: actimonda",
  isActive: false,
}
const bkkHenschelPlus: HealthInsurance = {
  id: 113,
  name: "BKK Henschel plus - jetzt: Continentale BKK",
  isActive: false,
}
const bkkKassana: HealthInsurance = {
  id: 114,
  name: "BKK Kassana - jetzt: BKK VerbundPlus",
  isActive: false,
}
const bkkManMtu: HealthInsurance = {
  id: 115,
  name: "BKK MAN und MTU - jetzt: Audi BKK",
  isActive: false,
}
const bkkMedicus: HealthInsurance = {
  id: 116,
  name: "BKK MEDICUS - jetzt: BKK VBU",
  isActive: false,
}
const bkkMelittaPlus: HealthInsurance = {
  id: 117,
  name: "BKK Melitta Plus - jetzt: BKK Melitta HMR",
  isActive: false,
}
const bkkMem: HealthInsurance = {
  id: 118,
  name: "BKK MEM - jetzt Metzinger BKK",
  isActive: false,
}
const bkkPhoenix: HealthInsurance = {
  id: 119,
  name: "BKK PHOENIX - jetzt: Novitas BKK",
  isActive: false,
}
const bkkRwe: HealthInsurance = {
  id: 120,
  name: "BKK RWE - jetzt: energie BKK",
  isActive: false,
}
const bkkSh: HealthInsurance = {
  id: 121,
  name: "BKK S-H - jetzt: BKK VBU",
  isActive: false,
}
const bkkSchwesternschaftBrk: HealthInsurance = {
  id: 122,
  name: "BKK Schwesternschaft v. BRK - jetzt: BKK ProVita",
  isActive: false,
}
const bkkStadtAugsburg: HealthInsurance = {
  id: 123,
  name: "BKK Stadt Augsburg - jetzt: Audi BKK",
  isActive: false,
}
const bkkTextilgruppeHof: HealthInsurance = {
  id: 124,
  name: "BKK Textilgruppe Hof - jetzt: mhplus",
  isActive: false,
}
const bkkVital: HealthInsurance = {
  id: 125,
  name: "BKK Vital - jetzt: BKK Pfalz",
  isActive: false,
}
const brandenburgischeBkk: HealthInsurance = {
  id: 126,
  name: "Brandenburgische BKK - jetzt: BKK VBU",
  isActive: false,
}
const deutscheBkk: HealthInsurance = {
  id: 127,
  name: "DEUTSCHE BKK - jetzt: BARMER",
  isActive: false,
}
const eonBetriebskrankenkasse: HealthInsurance = {
  id: 128,
  name: "E.ON Betriebskrankenkasse - jetzt: energie-BKK",
  isActive: false,
}
const essoBkk: HealthInsurance = {
  id: 129,
  name: "ESSO BKK - jetzt: Novitas BKK",
  isActive: false,
}
const heagBkk: HealthInsurance = {
  id: 130,
  name: "HEAG BKK - jetzt: Linde BKK",
  isActive: false,
}
const hypovereinsbankBkk: HealthInsurance = {
  id: 131,
  name: "Hypovereinsbank BKK - jetzt: BKK Mobil Oil",
  isActive: false,
}
const metzingerBkk: HealthInsurance = {
  id: 132,
  name: "Metzinger BKK - jetzt: mhplus",
  isActive: false,
}
const saintGobainBkk: HealthInsurance = {
  id: 133,
  name: "SAINT-GOBAIN BKK",
  isActive: false,
}
const schwennigerKrankenkasse: HealthInsurance = {
  id: 134,
  name: "Schwenniger Krankenkasse - jetzt: vivida bkk",
  isActive: false,
}
const shellBkkLife: HealthInsurance = {
  id: 135,
  name: "Shell BKK/LIFE - jetzt: DAK Gesundheit",
  isActive: false,
}
const siemagBkk: HealthInsurance = {
  id: 136,
  name: "SIEMAG BKK - jetzt: Novitas BKK",
  isActive: false,
}
const tbk: HealthInsurance = {
  id: 137,
  name: "TBK (Thüringer Betriebskrankenkasse)",
  isActive: false,
}
const vaillantBkk: HealthInsurance = {
  id: 138,
  name: "Vaillant BKK - jetzt: pronova BKK",
  isActive: false,
}
const vereinigteBkk: HealthInsurance = {
  id: 139,
  name: "Vereinigte BKK - jetzt: BKK VBU",
  isActive: false,
}
const wielandBkk: HealthInsurance = {
  id: 140,
  name: "Wieland BKK - jetzt: BKK Verbund Plus",
  isActive: false,
}
